var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    {
      style: { background: _vm.$vuetify.theme.themes[_vm.theme].background },
      attrs: { id: "container" }
    },
    [
      _c(
        "loader",
        { attrs: { "is-loading": _vm.loading } },
        [
          _c("c-navigation-drawer", {
            style: {
              background:
                _vm.$vuetify.theme.themes[_vm.theme].secondarybackground
            }
          }),
          _vm._v(" "),
          _c("c-right-drawer", {
            style: {
              background:
                _vm.$vuetify.theme.themes[_vm.theme].secondarybackground
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("router-view", { attrs: { name: "right-drawer" } })
                  ]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.isCollapse,
              callback: function($$v) {
                _vm.isCollapse = $$v
              },
              expression: "isCollapse"
            }
          }),
          _vm._v(" "),
          _c("c-toolbar"),
          _vm._v(" "),
          _c(
            "v-main",
            [
              _vm.isInactive
                ? _c(
                    "v-container",
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "mx-n0",
                          attrs: { type: "error", color: "orange" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          href:
                                            "https://engiegbs.service-now.com/myportal?id=sc_cat_item&sys_id=62c890121b6f90941b9610229b4bcba5",
                                          target: "_blank",
                                          elevation: "8",
                                          depressed: "",
                                          outilned: "",
                                          color: "warning"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              MyPortal - Service Portal\n              "
                                        ),
                                        _c("v-icon", [_vm._v("mdi-link")])
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            125715624
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n            Votre compte GTF est actuellement désactivé. Pour le réactiver\n            veuillez faire une demande sur MyPortal.\n            "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            Sélectionnez l'application : Habilitation GTF (HAB GTF) et dans la\n            Description du problème indiquez par exemple :\n            "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            Merci de réactiver mon compte GTF svp\n          "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.authenticated
                ? _c(
                    "v-container",
                    { attrs: { "text-xs-center": "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            "align-center": "",
                            "justify-center": "",
                            row: "",
                            wrap: ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    value: true,
                                    color: "error",
                                    icon: "warning",
                                    outline: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.generateMessage(
                                          "boilerplate.disconnected_message"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-container",
                {
                  staticClass: "under-nav-bar-container",
                  attrs: { fluid: "" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "under-nav-bar" },
                    [
                      _c("router-view", {
                        style: {
                          background:
                            _vm.$vuetify.theme.themes[_vm.theme]
                              .secondarybackground
                        },
                        attrs: { name: "top" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c("router-view", { key: _vm.$route.fullPath })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "custom-boilerplate-modal",
            [_c("router-view", { attrs: { name: "dialog" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "v-fab-transition",
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "scroll",
                      rawName: "v-scroll",
                      value: _vm.onScroll,
                      expression: "onScroll"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fab,
                      expression: "fab"
                    }
                  ],
                  attrs: {
                    color: "error",
                    small: "",
                    fixed: "",
                    bottom: "",
                    right: "",
                    fab: ""
                  },
                  on: { click: _vm.toTop }
                },
                [_c("v-icon", [_vm._v("keyboard_arrow_up")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("custom-store-dialog"),
          _vm._v(" "),
          _c("custom-snackbar"),
          _vm._v(" "),
          _c("custom-selected-currents")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }